module.exports = "assets/img/other-gite-1.jpg";